import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";

function UserDepartments() {
  return (
    <Crud
      title="User Departments"
      getUrl={() => "/User/Department_GetList"}
      // INSERT
      insertUrl={() => "/User/Department_Insert"}
      insertParams={({ userId }, { description, callRecording }) => ({
        Description: description,
        CallRecording: callRecording,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/User/Department_Update"}
      updateParams={(
        { userId },
        { idDepartment, description, callRecording }
      ) => ({
        IdDepartment: idDepartment,
        Description: description,
        CallRecording: callRecording,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/User/Department_Delete"}
      deleteParams={({ userId }, id) => ({
        IdDepartment: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idDepartment"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="description"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Description
      </TableHeaderColumn>
      <TableHeaderColumn
        dataAlign="center"
        dataFormat={moveFormatter}
        editable={{
          type: "checkbox",
          options: {
            values: "true:false",
          },
        }}
        dataField="callRecording"
      >
        Recording
      </TableHeaderColumn>
    </Crud>
  );
}

export default UserDepartments;
